var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48295"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 10.5,
    cy: 10.4999,
    r: 10.5,
    fill: "#86FFC6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6264 13.8298L9.17316 12.3766L7.71994 10.9234C7.3925 10.5851 7.34193 10.0655 7.598 9.67043C7.84584 9.2414 8.2909 8.9638 8.78522 8.92992C9.4518 8.94319 10.2144 9.07714 10.6902 8.60137L12.4233 6.86761C12.7351 6.55169 13.2436 6.54745 13.5606 6.85814L14.6916 7.98723C15.0023 8.30421 14.9981 8.81277 14.6821 9.12453L12.9484 10.8602C12.4726 11.3359 12.6072 12.0986 12.6198 12.7652C12.5857 13.2592 12.3082 13.704 11.8793 13.9517C11.4842 14.2078 10.9647 14.1572 10.6264 13.8298Z",
    fill: "#010103",
    stroke: "#010103",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-29"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17285 12.3774L6.07686 15.4734L9.17285 12.3774Z",
    fill: "#010103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17285 12.3774L6.07686 15.4734",
    stroke: "#010103",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPin);
export default __webpack_public_path__ + "static/media/userPin.1e29bb99f05dac7704a679121a01af32.svg";
export { ForwardRef as ReactComponent };